import { render, staticRenderFns } from "./SpaceCreateMenu.vue?vue&type=template&id=92eb7ff8&"
import script from "./SpaceCreateMenu.vue?vue&type=script&lang=js&"
export * from "./SpaceCreateMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports